/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SettingsGrid extends SiteEntityGrid<SettingsRow, any> {
        protected getColumnsKey() { return 'Data.Settings'; }
        protected getDialogType() { return SettingsDialog; }
        protected getIdProperty() { return SettingsRow.idProperty; }
        protected getLocalTextPrefix() { return SettingsRow.localTextPrefix; }
        protected getService() { return SettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.push({
                title: 'Reset All Caches',
                icon: 'fa fa-recycle',
                onClick: () => {
                    SettingsService.ResetCache({}, (response) => {
                        if (response.Error) {
                            Q.notifyError(response.Error.Message);
                        } else {
                            Q.notifySuccess(Q.text("Site.Cache.CacheResetSuccess"), Q.text("Site.Cache.CacheResetTitle"));
                        }
                    });
                },
                separator: 'left'
            });

            return buttons;
        }
    }
}